export default function getResource(label) {
    const resources = {
        personalizedPlacements: 'Placements personnalisés'
    };

    return resources[label];
}
